<template>
  <div :class="['flex justify-center items-center', fullScreen ? 'fixed inset-0 bg-background bg-opacity-80 z-50' : '']">
    <div class="text-center">
      <svg
          class="animate-spin h-8 w-8 text-primary mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
      >
        <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
        ></circle>
        <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      <p v-if="message" class="mt-2 text-text-secondary">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLoading',
  props: {
    message: {
      type: String,
      default: 'Loading...'
    },
    fullScreen: {
      type: Boolean,
      default: false
    }
  }
}
</script>